import axios from 'axios';

/**
 * Fetch subscription list for currency switching
 * @param {string} currency - Target currency code (e.g., 'USD', 'EUR')
 * @returns {Promise} API response with subscription list
 */
export const getCurrencySwitchSubscriptions = (currency) => {
    return axios.get(`/billing/basic/currencyswitch/subscription?currency=${currency}`);
};

/**
 * Switch currency for account with payment details
 * @param {Object} params - Currency switch parameters including payment info, contact details, etc.
 * @returns {Promise} API response with currency switch result
 */
export const switchCurrency = (params) => {
    return axios.post('/opc/switch-currency', params);
};
